export default "Welcome to the Image Filtering Workshop! Today we'll learn how computers process and transform images using filters.\n"